import React, {useCallback} from 'react';
import styles from './DocsElement.css'
import docs from "../utils/docs.json";
import {ExternalLinkIcon} from '@chakra-ui/icons'

const DocsElement = (props) => {

    return (
        <a className='alert_documentation' href={props?.docs || "#"} target="_blank" rel="noreferrer">
            <div className="root_element">
                {/*<ExternalLinkIcon w={6} h={6}/>*/}
                <p>?</p>
            </div>
        </a>
    );
};

export default DocsElement;
